module.exports = __webpack_public_path__ + "static/resan-logo-4e363913edac18f3e6f95e38d6a426a0.png";